var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55557 1H5.44446V1.55556H6.55557V1ZM5.44445 1.55566H4.33334V2.11122H5.44445V1.55566ZM3.22223 2.11133H4.33334V2.66688H3.22223V2.11133ZM3.22223 2.6665H2.11111V3.22206H3.22223V2.6665ZM2.11111 3.77783H3.22223V4.33339H2.11111V3.77783ZM4.33334 4.3335H3.22223V4.88905H4.33334V4.3335ZM4.33334 4.88867H5.44445V5.44423H4.33334V4.88867ZM7.66665 1.55566H6.55554V2.11122H7.66665V1.55566ZM7.66666 2.11133H8.77777V2.66688H7.66666V2.11133ZM9.88888 2.6665H8.77777V3.22206H9.88888V2.6665ZM8.77779 3.77772H9.8889V3.22217H11V3.77772V8.22217V8.77772H9.8889V9.33328H8.77779V9.88883H7.66668V10.4444H6.55557V10.9999H5.44446V10.4444H6.00001V5.99995H5.44446V5.44439H6.55557V4.88883H7.66668V4.33328H8.77779V3.77772ZM1.55556 8.22217V3.77772H2.11111V3.22217H1V3.77772V8.22217V8.77772H2.11111V8.22217H1.55556ZM2.11111 8.77783H3.22223V9.33339H2.11111V8.77783ZM4.33334 9.3335H3.22223V9.88905H4.33334V9.3335ZM4.33334 9.88867H5.44445V10.4442H4.33334V9.88867Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxS);
export default __webpack_public_path__ + "static/media/box-s.8697eacc532524d7e84d8b4e2961618a.svg";
export { ForwardRef as ReactComponent };